

var $ = jQuery.noConflict();

$(function(){

       /* var opacityDuration = 25;

    setTimeout(function() {
        
        $('body').addClass('loading-screen-logo-active');

       }, opacityDuration);
	   
*/

/*
$(this).scrollTop(0); 


	window.onload = function() {
		//alert('window.onload alert'); 
		$(this).scrollTop(0); 
		//alert('window.onload alert22')
	};
	window.onload = function() {
		setTimeout(function() {
			window.scrollTo(0, 0);
		}, 0);
	};

        var opacityDuration1 = 350;
		window.scrollTo(0, 0);
		
    setTimeout(function() {
        
        $('body').addClass('loading-screen-1');
		//$(this).scrollTop(0); 
		 window.scrollTo(0, 0);
       }, opacityDuration1);

    setTimeout(function() {
        
        $('body').addClass('loading-screen-2');
		//$(this).scrollTop(0); 
       }, opacityDuration1 * 2);

    setTimeout(function() {
        
        $('body').addClass('loading-screen-3');
		//$(this).scrollTop(0); 
       }, opacityDuration1 * 3);

    setTimeout(function() {
        
        $('body').addClass('loading-screen-4');
		//$(this).scrollTop(0); 
       }, opacityDuration1 * 4);

    setTimeout(function() {
        
        $('body').addClass('loading-screen-active');
		//$(this).scrollTop(0); 

       }, 2500);

    setTimeout(function() {
        
        $('body').addClass('loading-screen-active-remove-logo-zindex');
		//$(this).scrollTop(0); 


       }, 4000);

    setTimeout(function() {
        
        $('body').addClass('loading-screen-active-iconscroll');
		//$(this).scrollTop(0); 


       }, 4000);

*/

						
function homeScroll() {
	$('a.icon-scroll').on('click',function (e) {
		
		e.preventDefault();

		var target = this.hash;
		var $target = $(target);

		if ($(window).width() > 1299) {
			var headerOffset = 90;
		} else {
			var headerOffset = 90;
		};
		
		$('html, body').stop().animate({
			
			'scrollTop': $target.offset().top - headerOffset
		//}, 900, 'swing', function () {
		}, 1500, 'swing', function () {
		
		});
	});	

}		

 homeScroll();


	//window.onunload = function(){};
	//alert('inline alert');
		
		/**/
	
	//var documentWidth = $(document).width();
	var documentWidth = $(window).outerWidth(); 

	
	if (documentWidth > 1200) {		
		
		var parallaxVar = 0.125 ;
		var parallaxVar2 = 0.065;
		var parallaxVar3 = 0.175;
		
	} else {
		
		var parallaxVar = 0;
		var parallaxVar2 = 0;
		var parallaxVar3 = 0;		
	}



function parallaxSite() {
	
	//var documentWidth = $(document).width();
	var documentWidth = $(window).outerWidth(); 
	
	//console.log(documentWidth);
	
	if (documentWidth > 1200) {			
		var parallaxVar = 0.125 ;
		var parallaxVar2 = 0.065;
		var parallaxVar3 = 0.175;
		var parallaxVar4 = 0.2;
	
	} else {				
		var parallaxVar = 0;
		var parallaxVar2 = 0;
		var parallaxVar3 = 0;		
		var parallaxVar4 = 0;		
	}

	boxSectionArray = [];
    


    $('.about-us-photo-1').parallax2("", parallaxVar);
    $('.about-us-photo-1 > div').parallax2("", parallaxVar2);
    $('.about-us-photo-2').parallax2("", parallaxVar);
    $('.about-us-photo-2 > div').parallax2("", parallaxVar2 + 0.015);
    $('.about-us-photo-3').parallax2("", parallaxVar + 0.01);
   	$('.about-us-photo-3 > div').parallax2("", parallaxVar2);
    $('.about-us-photo-4').parallax2("", parallaxVar + 0.015);
    $('.about-us-photo-4 > div').parallax2("", parallaxVar2);

    $('#about-us > div + div img').parallax2("", parallaxVar2);
	
    $('.about-us-photo-5').parallax2("", parallaxVar);
    $('.about-us-photo-5 > div').parallax2("", parallaxVar2);

    $('.video-1').parallax2("", parallaxVar2);
    $('.video-1 video').parallax2("", parallaxVar);

    //$('.logo-fdp').parallax2("", parallaxVar2);

	 $(".about-us-photo ").each(function() {
		dataId = $(this).attr('data-id');
		boxSectionArray.push(dataId);
	});		
		
	/*var i;
	for (i = 6; i < 16; i++) {


		
	$('.about-us-photo-' + i ).parallax2("", parallaxVar / 2);
	//$('.about-us-photo-' + i  + ' > div').parallax2("", parallaxVar2 / 2);

		
	} // for	
	
*/

	
	
} // parallaxSite()

parallaxSite();

/*
$('#company-stats > div > div span span').counterUp({
	delay: 10,
	//time: 1750
	time: 2500
});
*/

/*
$('#company-stats > div > div span span').viewportChecker({    
	offset: 50,
	callbackFunction: function(elem, action){

		$dataVideoId = $(elem).parent().parent().attr('data-video');
		
		$(elem).counterUp({
			delay: 10,
			//time: 1750
			time: 2500
		});
		
	}

});
*/

	
$('.video-1').viewportChecker({    
	offset: -750,
	callbackFunction: function(elem, action){

		$dataVideoId = $(elem).parent().attr('data-video');
		
		$(elem).append('<video autoplay="" loop="" muted="" playsinline=""><source id="mp4" src="' + $dataVideoId +'" type="video/mp4"></video>');
	}

});

	
$('.about-photos-2').viewportChecker({    
	offset: 300

});



var distanceSR = '80px';
var durationSR = 750;
var durationSR = 1250;
var delaySR = 333;
var delay2SR = 250;

	  //div:not(.page-title) h1, 
	sr.reveal('#about-us h1, #about-us p, #company-stats h2, .why-section h2, .why-section h3, .why-section p, .about-photos-2 h2, .about-mission p, .about-mission h2, .about-mission h3, .template-page-fdp-template-about-us .custom-brands-list .h3, .template-page-fdp-template-about-us .custom-brands-list .h5, body .customer-review-block .halo-block-header .h5, body .customer-review-block .halo-block-header h3, a.button, #company-stats div > .h4, .read-more-button-heading', { 
		
	//scale: 1,
		duration: durationSR, 
		delay: delay2SR,
		distance: distanceSR,
		vFactor: 0.03,
		mobile: false,
		opacity: 0,
		scale: 1,
		mobile: true
		
	  });	 
		 
 
	  //div:not(.page-title) h1, 
	sr.reveal('.video-section', { 
		
	//scale: 1,
		duration: durationSR, 
		delay: delay2SR,
		distance: distanceSR,
		vFactor: 0.01,
		mobile: false,
		opacity: 0,
		scale: 1,
		mobile: true
		
	  });	 
		 
 
   
	sr.reveal('.why-list-wrapper > div > div',{
		
		duration: durationSR, 
		delay: delay2SR,
		distance: distanceSR,
		vFactor: 0.03,
		mobile: false,
		opacity: 0,
		scale: 1,
		mobile: true

	},150); 
	  
   
	sr.reveal('#company-stats > div > div',{
		
		duration: durationSR, 
		delay: delay2SR,
		distance: distanceSR,
		vFactor: 0.03,
		mobile: false,
		opacity: 0,
		scale: 1,
		mobile: true

	},150); 
	  
	sr.reveal('#contact-bottom > div > div',{scale: 1,
		duration: durationSR, 
		delay: delay2SR,
		distance: distanceSR,
		vFactor: 0.03,
		mobile: false
		}
		, 250);


		productAboutGrid = $('')


		




/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */		
var rtime;
var timeout = false;
var delta = 100;
$(window).resize(function() {
    rtime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(resizeend, delta);
    }
});

function resizeend() {
    if (new Date() - rtime < delta) {
        setTimeout(resizeend, delta);
    } else {
        timeout = false;

		parallaxSite();		
		
    }           
    
} // resizeend()


}) // document ready